import { createI18n } from 'vue-i18n'
import axios from 'axios'

const defaultLocale = 'en-GB'
const currentLocale = window.app.product_list.siteLanguageHrefLang

export const i18n = createI18n({
    legacy: false,
    locale: currentLocale,
    fallbackLocale: defaultLocale,
    messages: {}
})

// helper to load any locale file
async function loadLocaleMessages(locale) {
    const url = window.app.product_list.translationsAssetsPath + `/${locale}.json`
    const { data } = await axios.get(url)
    i18n.global.setLocaleMessage(locale, data)
}

export async function loadLanguageAsync() {
    // make sure fallback is loaded
    await loadLocaleMessages(defaultLocale)

    // load the actual current locale, if different
    if (currentLocale !== defaultLocale) {
        await loadLocaleMessages(currentLocale)
    }

    // switch active locale
    i18n.global.locale.value = currentLocale
}
